<template>
  <LKRoadmapsFeedModalContainer
    content-class="delete"
    @close="$emit('close')"
  >
    <div class="text-sm-bold mod--delete">
      {{ options.title }}
    </div>

    <div class="delete-attention__buttons">
      <div
        class="text-sm-bold mod--delete-yes"
        @click="onRemove"
        v-text="'Да'"
      />
      <div
        class="text-sm-bold mod--delete-no"
        @click="close"
        v-text="'Нет'"
      />
    </div>
  </LKRoadmapsFeedModalContainer>
</template>

<script>
import LKRoadmapsFeedModalContainer from './LKRoadmapsFeedModalContainer.vue'


export default {
  name: 'LKRoadmapsFeedModalConfirm',
  components: {
    LKRoadmapsFeedModalContainer,
  },
  props: {
    options: {
      type: Object,
    },
  },
  data: () => ({
    isLoading: false,
  }),
  methods: {
    close(flag = false) {
      this.$emit('close', flag)
    },
    async onRemove() {
      this.isLoading = true

      try {
        await this.options.action()
        this.close(true)
      } catch (e) {
        this.$notice.errors(e)
      }

      this.isLoading = false
    },
  },
}
</script>
